import { Audit, Diagnosis } from "@/interfaces/Company";
import { encryptId } from "@/utils/utilsMethods";
import { Badge } from "antd";
import React, { useState } from "react";
import { CgEditBlackPoint } from "react-icons/cg";
import { CiCalendarDate } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import InfoConsultors from "./InfoProfile";
import {
  COMPANY_DATA_CONFIG,
  CompanyContainData,
  isAudit,
} from "../utils/constants";
import { AUDIT_MODES_CONFIG } from "@/Features/Audit/utils/constants";

interface CompanyDataProps {
  // audits?: Audit[];
  data?: Audit[] | Diagnosis[];
  // diagnosis?: Diagnosis[]
  companyid: number;
  dataType: CompanyContainData;
}

export const DataItemList = ({
  data,
  dataType,
}: {
  data: Audit | Diagnosis;
  dataType: CompanyContainData;
}) => {
  const navigate = useNavigate();

  return (
    <>
      <button
        type="button"
        className="w-full p-2 border rounded-lg flex flex-col justify-evenly items-start gap-2 cursor-pointer hover:bg-gradient-to-br from-zinc-50 via-slate-100 to-zinc-100 active:bg-slate-100 transition-all my-2"
        onClick={() =>
          navigate(
            `/app/companies/${dataType}/${encryptId(
              data.company.toString(),
            )}?${COMPANY_DATA_CONFIG[dataType].fetchData}=${encryptId(data.id.toString())}`,
          )
        }
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 text-gray-500">
            <CiCalendarDate />
            <span>Fecha</span>
          </div>
          {data.date_elabored.toString()}
        </div>
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 text-gray-500">
            <CiCalendarDate />
            <span>Nivel PESV</span>
          </div>
          <span className="font-bold ml-2">
            {data.type_detail?.name ? data.type_detail?.name.toUpperCase() : ""}
          </span>
        </div>
        {dataType === COMPANY_DATA_CONFIG.audits.typeData && isAudit(data) && (
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2 text-gray-500">
              <CiCalendarDate />
              <span>Modo</span>
            </div>
            <Badge
              count={AUDIT_MODES_CONFIG[data.audit_mode].label}
              color={AUDIT_MODES_CONFIG[data.audit_mode].hexColor}
            />
          </div>
        )}

        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 text-gray-500">
            <CgEditBlackPoint />
            <span>Estado</span>
          </div>
          <Badge
            count={
              (data.in_progress && "En Progreso") ||
              (data.external_count_complete && "Conteo finalizado") ||
              (data.in_checklist && "Lista de chequeo") ||
              "Finalizado"
            }
            color={
              data.in_progress
                ? data.external_count_complete
                  ? "#7e22ce" // Color para "Conteo finalizado"
                  : undefined // Color predeterminado para "En Progreso"
                : "#86EFAC" // Color para "Completado"
            }
          />
        </div>
        {data.consultor_detail && (
          <div className="flex items-center justify-between w-full">
            <InfoConsultors consultand={data.consultor_detail} />
          </div>
        )}
      </button>
    </>
  );
};

export default function CompanyData({
  data,
  companyid,
  dataType,
}: CompanyDataProps) {
  const [showAll] = useState(false);
  // Sort the diagnosis array by is_finalized, with finalized items appearing last
  const sortedAuditsOrDianosis = [...(data || [])].sort((a, b) => b.id - a.id);
  const displayedAuditsOrDiagnosis = showAll
    ? sortedAuditsOrDianosis
    : sortedAuditsOrDianosis.slice(0, 2); // Muestra cuantos items se muestran

  const router = useNavigate();
  return (
    <>
      {displayedAuditsOrDiagnosis.map((data) => (
        <DataItemList key={data.id} data={data} dataType={dataType} />
      ))}
      {data && data.length > 2 && !showAll && (
        <button
          onClick={() =>
            router(
              `/app/companies/audits/history/${encryptId(
                companyid.toString(),
              )}`,
            )
          }
          className="w-full p-2 border rounded-lg flex justify-center items-center gap-2 cursor-pointer hover:bg-gradient-to-br from-zinc-50 via-slate-100 to-zinc-100 active:bg-slate-100 transition-all my-2"
        >
          Ver más
        </button>
      )}
    </>
  );
}
